import React, { useEffect, useState } from "react";
import styles from "./PretestCard.module.scss";
import { useDataStore } from "store/DataStoreContext";
import Card from "./Card";
import _ from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { LeftArrow, RightArrow } from "../BundleCard/arrow";
import "react-horizontal-scrolling-menu/dist/styles.css";
import usePreventBodyScroll from "../BundleCard/usePreventBodyScroll";
import useWindowSize from "hook/useWindowSize";

const PretestCard = ({ handleClickCard }) => {
  const {
    state: { pretest },
  } = useDataStore();
  const history = useHistory();

  const [isHome, setIsHome] = useState(false);
  const { disableScroll, enableScroll } = usePreventBodyScroll();
  const { width } = useWindowSize();

  useEffect(() => {
    setIsHome(_.includes(["/home", "/", ""], history.location.pathname));
  }, []);

  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 3;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  return (
    <div
      className={styles.bundle_card_container}
      onMouseEnter={disableScroll}
      onMouseLeave={enableScroll}
    >
      {isHome ? (
        <div>
          <ScrollMenu
            // LeftArrow={width >= 1000 ? LeftArrow : null}
            // RightArrow={width >= 1000 ? RightArrow : null}
            onWheel={onWheel}
          >
            {pretest.data.map((pretest, i) => (
              <Card
                pretest={pretest}
                key={i}
                handleClickCard={handleClickCard}
              />
            ))}
          </ScrollMenu>
        </div>
      ) : (
        pretest.data.map((pretest, i) => (
          <Card pretest={pretest} key={i} handleClickCard={handleClickCard} />
        ))
      )}
    </div>
  );
};

export default PretestCard;
